<template>
  <v-form v-model="valid" ref="mainForm">
    <TextFieldLive
      code="contact_prenom"
      v-model="sasInscription.prenomProcheAidant"
      :live="liveSasInscription(7704)"
      :disabled="checkingContact"
      @eudo-updated="checkContact"
    />
    <TextFieldLive
      code="contact_nom"
      v-model="sasInscription.nomProcheAidant"
      :live="liveSasInscription(7705)"
      :disabled="checkingContact"
      @eudo-updated="checkContact"
    />
    <DatePickerLive
      code="contact_datedenaissance"
      v-model="sasInscription.dateDeNaissanceProcheAidant"
      :live="liveSasInscription(7717)"
      :disabled="checkingContact"
      @eudo-updated="checkContact"
    />
    <TextFieldLive
      code="contact_courriel"
      v-model="sasInscription.adresseCourrielProcheAidant"
      :live="liveSasInscription(7706)"
      :disabled="checkingContact"
      @eudo-updated="checkContact"
    />
    <v-alert type="error" text icon="mdi-alert-circle-outline"
      v-if="this.contactExistant">
      <ressource code="compte-existant" />
    </v-alert>
    <v-checkbox v-show="false"
      class="list_counter_validator my-2 ml-6 p-0"
      :input-value="this.contactExistant"
      :rules="[(v) => !v || 'error-compte-existant']">
    </v-checkbox>
    <CatalogueLive code="contact_sexe" v-model="sasInscription.sexe" :live="liveSasInscription(7711)" />
    <TextFieldLive :eudoIf="estSexeIdentifie" code="contact_autre1" v-model="sasInscription.jeMIdentifieComme" :live="liveSasInscription(7710)" />
    <TextFieldLive code="contact_adresse1" v-model="sasInscription.rue1" :live="liveSasInscription(7713)" />
    <TextFieldLive code="contact_ville" v-model="sasInscription.ville" :live="liveSasInscription(7715)" />
    <TextFieldLive code="contact_code_postal" v-model="sasInscription.codePostal" :live="liveSasInscription(7716)" />
    <CatalogueLive code="contact_province" v-model="sasInscription.province" :live="liveSasInscription(7724)" />
    <v-checkbox
      class="list_counter_validator my-2 ml-6 p-0"
      :input-value="estProvinceQuebec(sasInscription.province)"
      :rules="[(v) => !!v || this.ressourcesByCode('residence-quebec')]"
    >
    </v-checkbox>
    <CatalogueLive code="contact_pays" v-model="sasInscription.pays" :live="liveSasInscription(7725)" />
    <v-checkbox
      class="list_counter_validator my-2 ml-6 p-0"
      :input-value="estPaysCanada(sasInscription.pays)"
      :rules="[(v) => !!v || this.ressourcesByCode('residence-canada')]"
    >
    </v-checkbox>
    <CatalogueLive
      :eudoIf="estProvinceQuebec(sasInscription.province)"
      code="contact_region"
      v-model="sasInscription.regionAdministrative"
      :live="liveSasInscription(7718)"
    />
    <CatalogueLive
      :eudoIf="estRegionCapitaleNationale"
      code="contact_portneuf"
      v-model="sasInscription.residezVousDansLaMrcDePortneuf"
      :live="liveSasInscription(7719)"
    />
    <TextFieldLive code="contact_cellulaire" v-model="sasInscription.cellulaireProcheAidant" :live="liveSasInscription(7720)" />
    <TextFieldLive code="contact_telephone" v-model="sasInscription.telephoneProcheAidant" :live="liveSasInscription(7707)" />
    <CatalogueLive code="contact_allergie" v-model="sasInscription.allergie" :live="liveSasInscription(7721)" />
    <TextFieldLive :eudoIf="estOuiAllergie" code="contact_autre2" v-model="sasInscription.precisionsAllergies" :live="liveSasInscription(7722)" />
    <CatalogueLive code="contact_notif" v-model="sasInscription.ouAvezVousEntenduParlerDeNous" :live="liveSasInscription(7723)" />
    <TextFieldLive :eudoIf="estSourceAutre" code="contact_autre3" v-model="sasInscription.precisionOrigine" :live="liveSasInscription(7732)" />
    <CatalogueLive code="contact_infolettre" v-model="sasConsentement.recevoirInfolettrePourLeProcheAidant" :live="liveSasConsentement(8902)" />
    <CatalogueLive code="contact_infolettre2" v-model="sasConsentement.recevoirInfolettreDuMonastere" :live="liveSasConsentement(8903)" />
    <MemoLive code="contact_infoadd" v-model="sasInscription.informationsAdditionnelles" :live="liveSasInscription(7794)" />
  </v-form>
</template>

<script>
import StepFormWithValidation from "@/components/core/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
import DatesHelpers from "@/components/ui/mixins/DatesHelpers"
import CheckContactExistant from "@/components/core/mixins/CheckContactExistant"
import { DESC_ID, CODES_CATALOGUES } from "@/constants"
import { mapGetters } from "vuex"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers, DatesHelpers, CheckContactExistant],
  props: {
    sas: { type: Object }
  },
  mounted() {
    this.checkContact()
  },
  computed: {
    ...mapGetters(["ressourcesByCode"]),
    sasInscription() {
      return this.sas.sasInscription
    },
    sasConsentement() {
      return this.sas.sasConsentement
    },
    estSexeIdentifie() {
      return this.getCatalogueCodeById(DESC_ID.SEXE, this.sasInscription.sexe) == CODES_CATALOGUES.CONTACT_SEXE.JE_M_IDENTIFIE_COMME
    },
    estOuiAllergie() {
      return this.estOui(this.sasInscription.allergie)
    },
    estRegionCapitaleNationale() {
      return (
        this.getCatalogueCodeById(DESC_ID.REGION_ADMINISTRATIVE, this.sasInscription.regionAdministrative) ==
        CODES_CATALOGUES.REGION_ADMINISTRATIVE.CAPITALE_NATIONALE
      )
    },
    estSourceAutre() {
      return this.getCatalogueCodeById(DESC_ID.SOURCE_INFO, this.sasInscription.ouAvezVousEntenduParlerDeNous) == CODES_CATALOGUES.SOURCE_INFO.AUTRE
    }
  },
  methods: {
    liveSasInscription(cle) {
      return { endpoint: "sas-inscription", cle: cle, fileId: this.sasInscription.id }
    },
    liveSasConsentement(cle) {
      return { endpoint: "sas-consentement", cle: cle, fileId: this.sasConsentement.id }
    },
    checkContact() {
      this.checkContactExistant(
        this.sasInscription.nomProcheAidant,
        this.sasInscription.prenomProcheAidant,
        this.sasInscription.dateDeNaissanceProcheAidant,
        this.sasInscription.adresseCourrielProcheAidant
      )
    }
  }
}
</script>

<style></style>
